export const stepsSettings = {
  "settings": [
    {
      "title": "Información personal",
      "percent": 20,
      "progress": {
        "maxPersent": 75,
        "title": "probabilidad de aprobación",
        "titlePercent": "15%",
        "footer": "por la información personal",
        "footerPercent": "+75%"
      },
      "actions": ["create"],
      "pixel": "ingresos_v2"
    }
  ],
  "replacements": {
    "Condiciones": {
      "type": "link",
      "text": "condiciones de uso",
      "to": "/condiciones-de-uso"
    },
    "Politica": {
      "type": "link",
      "text": "política de privacidad",
      "to": "/politica-de-privacidad"
    },
    "Name": {
      "type": "variable",
      "key": "firstname1"
    },
    "Value": {
      "type": "variable",
      "key": "amount"
    }
  },
  "desktopInputLayout": ["2 2 2 2 2 1"],
  "isOptions": ["firstname2"],
  "pixel": "datos_personales_v2"
}